"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var js_util_1 = require("@giphy/js-util");
var mergeAttribute = function mergeAttribute(attributes, newAttributes, key) {
  var _a;
  var result1 = (0, js_util_1.pick)(attributes, [key]);
  var result2 = (0, js_util_1.pick)(newAttributes, [key]);
  if (result1[key] && result2[key]) {
    return __assign(__assign(__assign({}, attributes), newAttributes), (_a = {}, _a[key] = result1[key] + ', ' + result2[key], _a));
  }
  return __assign(__assign({}, attributes), newAttributes);
};
exports.default = mergeAttribute;